import { setToast } from '@/entities/toast'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { Run } from '../models/Run'
import { fetchRuns } from './fetchRuns'

type CopyRunPayload = {
  runId: EntityId
}

export const copyRun = createAsyncThunk<Run | null, CopyRunPayload, ThunkApiContext>('runs/saveRun', async ({ runId }, { dispatch }) => {
  const run = await OLMSApiService.post<Run>('run/copy', runId)

  if (!run) {
    dispatch(setToast({
      open: true,
      severity: 'error',
      title: 'Copy run',
      content: 'Failed to copy run',
    }))

    return null
  }

  dispatch(setToast({
    open: true,
    severity: 'success',
    title: 'Copy run',
    content: 'Successfully copied run',
  }))

  await dispatch(fetchRuns())

  return run
})